export const AFFILIATE_CODE_QUERY_PARAM = 'affiliate_code'
const STORAGE_KEY = 'affiliateCode'
const TTL_MS = 7 * 24 * 60 * 60 * 1000

interface StoredAffiliateCode {
  code: string
  expiresAt: number
}

function readStored(): StoredAffiliateCode | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<StoredAffiliateCode>
    if (!parsed || typeof parsed.code !== 'string' || typeof parsed.expiresAt !== 'number') {
      localStorage.removeItem(STORAGE_KEY)
      return null
    }
    if (parsed.expiresAt <= Date.now()) {
      localStorage.removeItem(STORAGE_KEY)
      return null
    }
    return { code: parsed.code, expiresAt: parsed.expiresAt }
  } catch {
    return null
  }
}

export function storeAffiliateCode(code: string): void {
  const trimmed = String(code ?? '').trim()
  if (!trimmed) return
  try {
    const value: StoredAffiliateCode = { code: trimmed, expiresAt: Date.now() + TTL_MS }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value))
  } catch {
    return
  }
}

export function getStoredAffiliateCode(): string | undefined {
  return readStored()?.code
}

export function clearStoredAffiliateCode(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    return
  }
}

export function captureAffiliateCodeFromSearch(search: string): string | undefined {
  const code = new URLSearchParams(search).get(AFFILIATE_CODE_QUERY_PARAM)?.trim()
  if (!code) return undefined
  storeAffiliateCode(code)
  return code
}

export function buildShareCarPath(requestId: string, affiliateCode?: string | null): string {
  const params = new URLSearchParams({ request_id: requestId })
  if (affiliateCode) params.set(AFFILIATE_CODE_QUERY_PARAM, affiliateCode)
  return `/share-car?${params.toString()}`
}
